import { Box } from "@mui/material";

interface Props {
  city: string;
  country: string;
  image: any;
  address: string;
}

const HeadquarterCard: React.FC<Props> = ({
  country,
  city,
  image,
  address,
}) => {
  return (
    <Box
      p={2}
      mb={6}
      sx={{
        width: "100%",
        minHeight: "200px",
        display: "flex",
        flexDirection: "column",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            fontWeight: 600,
            fontSize: 30,
            lineHeight: 1.2,
            color: "#fff",
          }}
        >
          {city}
        </Box>
        <Box
          sx={{
            paddingTop: 1,
            fontSize: 20,
            lineHeight: 1.2,
            color: "#fff",
          }}
        >
          {country}
        </Box>
      </Box>
      <Box
        sx={{
          fontWeight: 600,
          color: "#fff",
        }}
      >
        {address}
      </Box>
    </Box>
  );
};

export default HeadquarterCard;
